function requestError(payload, status) {
  const error = new Error(
    payload?.error || "No pudimos cargar el catálogo de Astrea.",
  );
  error.code = payload?.code || "astrea_request_failed";
  error.status = status;
  return error;
}

export function createAstreaApi(
  getAccessToken,
  apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000",
) {
  async function request(path) {
    const token = getAccessToken ? await getAccessToken() : null;
    const response = await fetch(`${apiUrl}${path}`, {
      credentials: "include",
      headers: token ? { authorization: `Bearer ${token}` } : {},
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw requestError(payload, response.status);
    return payload.data;
  }

  return {
    listBooks() {
      return request("/api/mentis/v1/partner-catalog/astrea/books");
    },

    async getBookPdfSource(externalBookId) {
      const token = getAccessToken ? await getAccessToken() : null;
      return {
        url: `${apiUrl}/api/mentis/v1/partner-catalog/astrea/books/${encodeURIComponent(
          externalBookId,
        )}/pdf`,
        httpHeaders: token ? { authorization: `Bearer ${token}` } : {},
        withCredentials: true,
      };
    },
  };
}
